import { Button } from '@radix-ui/themes';

type Props = {
  visible: boolean;
  onClick: () => void;
};

const GoToTopButton = ({ visible, onClick }: Props) => {
  if (!visible) return null;
  return (
    <Button
      variant="solid"
      color="indigo"
      size="3"
      onClick={onClick}
      aria-label="Scroll back to top"
      className="go-to-top-button"
    >
      Go to top
    </Button>
  );
};

export default GoToTopButton;
